import request from '@/api/request'
import Qs from 'qs'
import { isAndroidIos,isAndroid} from '@/utils/validate'

// 会员状态
export const vipStatus = (params) => {
  return request({
    url: 'zhijie/vip/vipStatus',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
      ...params
    }
  })
}
// 增送优惠券
export const sendCoupon = (params) => {
  return request({
    url: 'zhijie/coupon/sendCoupon',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
      ...params
    }
  })
}
// 用戶是否发送优惠券
export const isSendCoupon = (params) => {
  return request({
    url: 'zhijie/coupon/isSendCoupon',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
      ...params
    }
  })
}


// 用户百融多头风险查询接口
export const riskquery = (params) => {
  return request({
    url: 'rocket/risk/query',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
    }
  })
}


// 智借首页
export const zhijieAppConfig = () => {
  return request({
    url: 'zhijie/appConfig/config',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
    }
  })
}

// 支付宝 app 参数
export const tradeAppPay = () => {
  return request({
    url: 'zhijie/alipay/tradeAppPay',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
    }
  })
}
// 支付宝支付结果保存
export const saveTradeAppPay = (data) => {
  return request({
    url: 'zhijie/alipay/saveTradeAppPay',
    method: 'get',
    params:{
      _token:localStorage.getItem('token'),
      ...data
    }
  })
}

// 速贷产品配置
export const sudaichannel = () => {
  return request({
    url: 'zhijie/sudai/channel',
    method: 'get',
  })
}

// 热点区域-借款申请
export const detectZone = (data) => {
  return request({
    url: 'rocket/loan/detectZone',
    method: 'post',
    data:{
     
      ...data
    }
  })
}
// 热点区域-确认接口验证
export const applyZone = (data) => {
  return request({
    url: 'rocket/loan/applyZone',
    method: 'post',
    data:{
     
      ...data
    }
  })
}

// 国美渠道获取下游产品协议
export const productchguomei = (params) => {
  return request({
    url: `/oapi/protocol/product/ch/${params}`,
    method: 'get',
    data:{
     
      // ...data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/Credit/zhijie.js